import { Star } from "lucide-react";
import Reveal from "./Reveal";
import { REVIEWS } from "../data/menu";

const Reviews = () => (
    <section id="reviews" data-testid="reviews-section" className="scroll-mt-24 border-y hairline bg-saga-creamdark/40 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <Reveal>
                <div className="max-w-2xl">
                    <p className="eyebrow">Reviews</p>
                    <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl">
                        Words from our guests
                    </h2>
                </div>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
                {REVIEWS.map((review, i) => (
                    <Reveal key={i} delay={i * 0.1} className="h-full">
                        <figure
                            data-testid={`review-${i}`}
                            className="flex h-full flex-col justify-between rounded-2xl border border-saga-red/15 bg-saga-creamlight p-8"
                        >
                            <div>
                                {review.stars && (
                                    <div className="flex gap-1" aria-label={`Rated ${review.stars} out of 5`}>
                                        {Array.from({ length: review.stars }).map((_, s) => (
                                            <Star key={s} className="h-4 w-4 fill-saga-red text-saga-red" aria-hidden="true" />
                                        ))}
                                    </div>
                                )}
                                {review.title && (
                                    <h3 className="mt-4 font-display text-xl font-semibold text-saga-ink">{review.title}</h3>
                                )}
                                <blockquote className="mt-4 text-sm leading-relaxed text-saga-ink/75 sm:text-base">
                                    “{review.quote}”
                                </blockquote>
                            </div>
                            <figcaption className="mt-6 text-[10px] font-semibold uppercase tracking-[0.2em] text-saga-ink/45">
                                {review.source}
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Reviews;
